<template>
  <section v-if="storeName.FR" class="fr-container">
    <ProductList
      :listCName="fr_threeColumn.className"
      :listContent="fr_threeColumn.content"
      :isScale="fr_threeColumn.isScale"
    />

    <SectionTitle>
      <template>
        <h3>
          <span>catégorie de</span>
          <span class="primary-color">produit</span>
        </h3>
      </template>
    </SectionTitle>

    <ProductList
      :listCName="fr_fourColumn.className"
      :listContent="fr_fourColumn.content"
      :isScale="fr_fourColumn.isScale"
    >
      <template #more>
        <span class="more">more</span>
      </template>
    </ProductList>
  </section>

  <section v-else-if="storeName.DE_s" class="de_s-container">
    <ProductList
      :moduleName="de_s_specials.module.name"
      :listCName="de_s_specials.className"
      :listContent="de_s_specials.content"
      :isScale="de_s_specials.isScale"
    />
    <ProductList
      :moduleName="de_s_Duschkabine.module.name"
      :moduleTitle="de_s_Duschkabine.module.title"
      :listCName="de_s_Duschkabine.className"
      :listContent="de_s_Duschkabine.content"
      :isScale="de_s_Duschkabine.isScale"
    />
    <ProductList
      :moduleName="de_s_Badspiegel.module.name"
      :moduleTitle="de_s_Badspiegel.module.title"
      :listCName="de_s_Badspiegel.className"
      :listContent="de_s_Badspiegel.content"
      :isScale="de_s_Badspiegel.isScale"
    />
    <ProductList
      :moduleName="de_s_Heizkörper.module.name"
      :moduleTitle="de_s_Heizkörper.module.title"
      :listCName="de_s_Heizkörper.className"
      :listContent="de_s_Heizkörper.content"
      :isScale="de_s_Heizkörper.isScale"
    />
    <ProductList
      :moduleName="de_s_Zubehören.module.name"
      :moduleTitle="de_s_Zubehören.module.title"
      :listCName="de_s_Zubehören.className"
      :listContent="de_s_Zubehören.content"
      :isScale="de_s_Zubehören.isScale"
    />
  </section>

  <section v-else-if="storeName.EE" class="ee-container">
    <SectionTitle>
      <h3>
        <span>top</span>
        &nbsp;
        <span class="p-t-c">sales</span>
      </h3>
    </SectionTitle>

    <ProductList
      :moduleName="ee_topSales.module.name"
      :listCName="ee_topSales.className"
      :listContent="ee_topSales.content"
      :isScale="ee_topSales.isScale"
    >
      <template #more>
        <span class="more">more</span>
      </template>
    </ProductList>

    <Slide
      v-if="ee_MainSwiper.isShow"
      :banners="ee_MainSwiper.banners"
      :swiperOption="ee_MainSwiper.swiperOption"
      :swiperName="ee_MainSwiper.name"
      :navigation="ee_MainSwiper.swiperOption.navigation"
    >
    </Slide>
    <SectionTitle>
      <h3>
        <span>shop</span>
        &nbsp;
        <span class="p-t-c">by elegant</span>
      </h3>
      <p>Choose your favorite products</p>
    </SectionTitle>

    <ProductList
      :moduleName="ee_Shop_By_Elegant.module.name"
      :listCName="ee_Shop_By_Elegant.className"
      :listContent="ee_Shop_By_Elegant.content"
      :isScale="ee_Shop_By_Elegant.isScale"
    ></ProductList>
  </section>
</template>

<script>
import ProductList from "../small/ProductList";
import SectionTitle from "../small/SectionTitle";
import Slide from "../small/Slide";

import { mapState } from "vuex";

export default {
  name: "store-container",
  data() {
    return {
      ee_topSales: {
        module: {
          name: "ee-product-list",
        },
        className: "three-column",
        isScale: true,
        content: [
          {
            id: 1,
            url: require("@/assets/img/EE/list-img1.png"),
            // imgLink: "xxxxxxxxxxxx",
            moreLink:
              "https://www.ebaystores.co.uk/Elegantshowers/SHOWER-ROOM-/_i.html?_fsub=36917458011&_sid=1189928441&_trksid=p4634.c0.m322",
            title: "SHOWER ENCLOSURE",
            secondaryMenu: [
              {
                name: "bifold shower enclosure",
                link:
                  "https://www.ebay.co.uk/itm/Bathroom-Bi-Fold-Shower-Door-Enclosure-Glass-Screen-FREE-DELIVERY-/191964432833",
              },
              {
                name: "walk in shower enclosure",
                link: "https://www.ebay.co.uk/itm/172520874895",
              },
              {
                name: "sliding shower enclosure",
                link:
                  "https://www.ebay.co.uk/itm/Sliding-Shower-Enclosure-And-Tray-Waste-Door-Side-Panel-safety-glass-/192092325991",
              },
              {
                name: "quadrant shower enclosure",
                link: "https://www.ebay.co.uk/itm/191965386448",
              },
            ],
          },
          {
            id: 2,
            url: require("@/assets/img/EE/list-img2.png"),
            // imgLink: "xxxxxxxxxxxx",
            moreLink:
              "https://www.ebaystores.co.uk/Elegantshowers/Mirror-/_i.html?_fsub=36917528011&_sid=1189928441&_trksid=p4634.c0.m322",
            title: "MIRRORS & CABINETS",
            secondaryMenu: [
              {
                name: "led mirror",
                link: "https://www.ebay.co.uk/itm/172369920218",
              },
              {
                name: "mirror cabinet",
                link: "https://www.ebay.co.uk/itm/192632185842",
              },
              {
                name: "shaver socket/bluetooth",
                link: "https://www.ebay.co.uk/itm/183433060592",
              },
              {
                name: "touch/button/infrared switch",
                link: "https://www.ebay.co.uk/itm/192632185842",
              },
            ],
          },
          {
            id: 3,
            url: require("@/assets/img/EE/list-img3.png"),
            // imgLink: "xxxxxxxxxxxx",
            moreLink:
              "https://www.ebaystores.co.uk/Elegantshowers/Radiators-/_i.html?_fsub=36917537011&_sid=1189928441&_trksid=p4634.c0.m322",
            title: "radiator",
            secondaryMenu: [
              {
                name: "Towel Rails",
                link: "https://www.ebay.co.uk/itm/182117468092",
              },
              {
                name: "Radiator Cover",
                link: "https://www.ebay.co.uk/itm/183859287034",
              },
              {
                name: "Traditional Rads",
                link: "https://www.ebay.co.uk/itm/182766714336",
              },
              {
                name: "Flat Panel/Oval Column",
                link: "https://www.ebay.co.uk/itm/182244200799",
              },
            ],
          },
        ],
      },
      ee_Shop_By_Elegant: {
        module: {
          name: "ee-p-list-main",
        },
        className: "five-column",
        isScale: true,
        content: [
          {
            id: 1,
            url: require("@/assets/img/EE/main-list_01.jpg"),
            imgLink:
              "https://www.ebaystores.co.uk/Elegantshowers/SHOWER-ROOM-/_i.html?_fsub=36917458011&_sid=1189928441&_trksid=p4634.c0.m322",
            title: "Enclosure",
          },
          {
            id: 2,
            url: require("@/assets/img/EE/main-list_02.jpg"),
            imgLink:
              "https://www.ebaystores.co.uk/Elegantshowers/SHOWER-TRAYS-/_i.html?_fsub=36917459011&_sid=1189928441&_trksid=p4634.c0.m322",
            title: "Tray",
          },
          {
            id: 3,
            url: require("@/assets/img/EE/main-list_03.jpg"),
            imgLink:
              "https://www.ebaystores.co.uk/Elegantshowers/Towel-Rail-/_i.html?_fsub=36917471011&_sid=1189928441&_trksid=p4634.c0.m322",
            title: "Towel Rail",
          },
          {
            id: 4,
            url: require("@/assets/img/EE/main-list_04.jpg"),
            imgLink:
              "https://www.ebaystores.co.uk/Elegantshowers/Radiators-/_i.html?_fsub=36917537011&_sid=1189928441&_trksid=p4634.c0.m322",
            title: "Radiator",
          },
          {
            id: 5,
            url: require("@/assets/img/EE/main-list_05.jpg"),
            imgLink:
              "https://www.ebaystores.co.uk/Elegantshowers/Kitchen-/_i.html?_fsub=36917539011&_sid=1189928441&_trksid=p4634.c0.m322",
            title: "Kitchen",
          },
          {
            id: 6,
            url: require("@/assets/img/EE/main-list_06.jpg"),
            imgLink:
              "https://www.ebaystores.co.uk/Elegantshowers/Mirror-/_i.html?_fsub=36917528011&_sid=1189928441&_trksid=p4634.c0.m322",
            title: "Mirror",
          },
          {
            id: 7,
            url: require("@/assets/img/EE/main-list_07.jpg"),
            imgLink:
              "https://www.ebaystores.co.uk/Elegantshowers/Mirror-Cabinet-/_i.html?_fsub=36917527011&_sid=1189928441&_trksid=p4634.c0.m322",
            title: "Mirror Cabinet",
          },
          {
            id: 8,
            url: require("@/assets/img/EE/main-list_08.jpg"),
            imgLink:
              "https://www.ebaystores.co.uk/Elegantshowers/Vanity-units-/_i.html?_fsub=36917529011&_sid=1189928441&_trksid=p4634.c0.m322",
            title: "Vanity Units",
          },
          {
            id: 9,
            url: require("@/assets/img/EE/main-list_09.jpg"),
            imgLink:
              "https://www.ebaystores.co.uk/Elegantshowers/TV-Stand-/_i.html?_fsub=36917538011&_sid=1189928441&_trksid=p4634.c0.m322",
            title: "tv stand",
          },
          {
            id: 10,
            url: require("@/assets/img/EE/main-list_10.jpg"),
            imgLink:
              "https://www.ebaystores.co.uk/Elegantshowers/SALES-/_i.html?_fsub=37102016011&_sid=1189928441&_trksid=p4634.c0.m322",
            title: "Sales",
          },
        ],
      },
      ee_MainSwiper: {
        name: "ee-banner",
        isShow: true,
        banners: [
          {
            id: 1,
            url: require("@/assets/img/EE/banner_1.jpg"),
            //   description: {
            //     title: "Artikelbeschreigung",
            //     paragraph: `<p>Große :120x90 cm</p>`,
            //     btnName: "$345.99",
            //     btnLink: "xxxxxxxxxx",
            //   },
            // link: "#",
          },
          {
            id: 2,
            url: require("@/assets/img/EE/banner_2.jpg"),
            link: "https://www.ebay.co.uk/itm/174218765817",
          },
          {
            id: 3,
            url: require("@/assets/img/EE/banner_3.jpg"),
            link: "https://www.ebay.co.uk/itm/174247562417",
          },
          {
            id: 4,
            url: require("@/assets/img/EE/banner_4.jpg"),
            link: "https://www.ebay.co.uk/itm/183859287034",
          },
        ],
        swiperOption: {
          speed: 1000,
          loop: true,
          autoplay: false,
          effect: "coverflow",
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        },
      },
      fr_threeColumn: {
        module: {
          name: "",
          title: null,
        },
        className: "three-column",
        isScale: true,
        content: [
          {
            id: 1,
            // url:
            // "https://masalledebain-enlignestore.fr/FReBay/FR-image2/01.jpg",
            url: require("@/assets/img/FR/big-list-01.jpg"),
            title: "en vente",
            imgLink: "https://www.ebay.fr/itm/233495559394",
          },
          {
            id: 2,
            // url:
            // "https://masalledebain-enlignestore.fr/FReBay/FR-image2/02.jpg",
            url: require("@/assets/img/FR/big-list-02.jpg"),
            title: "meilleures ventes",
            imgLink: "https://www.ebay.fr/itm/233610078526",
          },
          {
            id: 3,
            // url:
            // "https://masalledebain-enlignestore.fr/FReBay/FR-image2/03.jpg",
            url: require("@/assets/img/FR/big-list-03.jpg"),
            title: "soldes",
            imgLink: "https://www.ebay.fr/itm/233263370849",
          },
        ],
      },
      fr_fourColumn: {
        module: {
          name: "",
          title: null,
        },
        className: "four-column",
        isScale: true,
        content: [
          // (url: "https://masalledebain-enlignestore.fr/Showerroom/FWR/WR9/main3.jpg"),
          // (url: "https://masalledebain-enlignestore.fr/Accessories/GAST-GWST/GAST99/2-4.jpg"),
          // (url: "https://masalledebain-enlignestore.fr/Mirror-NEW/01/FTBM1117/main2.jpg"),
          // (url: "https://masalledebain-enlignestore.fr/Mirror-cabinet/FTBC001K/02/main1.jpg"),
          // (url: "https://masalledebain-enlignestore.fr/Accessories/FRFD/RFDC/RFDC%20(2).jpg"),
          // (url: "https://masalledebain-enlignestore.fr/Accessories/GTSS-R/R2/main1.jpg"),
          // (url: "https://masalledebain-enlignestore.fr/FRadiator/Radiator3/FR6-12W/main1.jpg"),
          // (url: "https://masalledebain-enlignestore.fr/Accessories/ShowerHead/GRSH/main3.jpg"),

          {
            id: 1,

            url: require("@/assets/img/FR/product-list_m1.png"),
            imgLink: "https://www.ebay.fr/itm/233566258805",
            moreLink:
              "https://www.ebaystores.fr/sunnyshowersfrance/Porte-de-douche-/_i.html?_fsub=30097606014&_sid=1857768744&_trksid=p4634.c0.m322",
            title: "cabine de douche",
          },
          {
            id: 2,
            url: require("@/assets/img/FR/product-list_m2.png"),
            imgLink: "https://www.ebay.fr/itm/233220662055",
            moreLink:
              "https://www.ebaystores.fr/sunnyshowersfrance/Receveur-de-douche-/_i.html?_fsub=30097605014&_sid=1857768744&_trksid=p4634.c0.m322",
            title: "receveur de douche",
          },
          {
            id: 3,
            url: require("@/assets/img/FR/product-list_m3.png"),
            imgLink: "https://www.ebay.fr/itm/233615117412",
            moreLink:
              "https://www.ebaystores.fr/sunnyshowersfrance/Miroir-de-salle-de-bain-/_i.html?_fsub=26925887014&_sid=1857768744&_trksid=p4634.c0.m322",
            title: "miroir de salle de bain",
          },
          {
            id: 4,
            url: require("@/assets/img/FR/product-list_m4.png"),
            imgLink: "https://www.ebay.fr/itm/232996517248",
            moreLink:
              "https://www.ebaystores.fr/sunnyshowersfrance/Armoire-de-Toilettes-/_i.html?_fsub=30097601014&_sid=1857768744&_trksid=p4634.c0.m322",
            title: "armoires miroir de salle de bain",
          },
          {
            id: 5,
            url: require("@/assets/img/FR/product-list_m5.png"),
            imgLink: "https://www.ebay.fr/itm/233495599173",
            moreLink:
              "https://www.ebaystores.fr/sunnyshowersfrance/Caniveau-de-douche-/_i.html?_fsub=32557261014&_sid=1857768744&_trksid=p4634.c0.m322",
            title: "caniveau de douche",
          },
          {
            id: 6,
            url: require("@/assets/img/FR/product-list_m6.png"),
            imgLink: "https://www.ebay.fr/itm/233610175036",
            moreLink:
              "https://www.ebaystores.fr/sunnyshowersfrance/Cabine-de-douche-/_i.html?_fsub=30097607014&_sid=1857768744&_trksid=p4634.c0.m322",
            title: "colonne de douche",
          },
          {
            id: 7,
            url: require("@/assets/img/FR/product-list_m7.png"),
            imgLink: "https://www.ebay.fr/itm/233262247779",
            moreLink:
              "https://www.ebaystores.fr/sunnyshowersfrance/Radiateur-a-eau-/_i.html?_fsub=30097602014&_sid=1857768744&_trksid=p4634.c0.m322",
            title: "radiateur",
          },
          {
            id: 8,
            url: require("@/assets/img/FR/product-list_m8.png"),
            imgLink: "https://www.ebay.fr/itm/233234831497",
            moreLink:
              "https://www.ebaystores.fr/sunnyshowersfrance/Accessoire-/_i.html?_fsub=30097604014&_sid=1857768744&_trksid=p4634.c0.m322",
            title: "accessoires",
          },
        ],
      },
      de_s_specials: {
        module: {
          name: "specials",
          title: null,
        },
        className: "three-column",
        isScale: false,
        content: [
          {
            id: 1,
            url: require("@/assets/img/DE_s/three_column1.png"),
            title: "neu",
            btnLink:
              "https://www.ebay.de/str/duschdepot?_oac=1&_dmd=1&_sop=10&rt=nc",
            // imgLink: "############",
          },
          {
            id: 2,
            url: require("@/assets/img/DE_s/three_column2.png"),
            title: "hot sale",
            btnLink:
              "https://www.ebay.de/str/duschdepot?_oac=1&_dmd=1&_sop=12&rt=nc",
            // imgLink: "###########",
          },
          {
            id: 3,
            url: require("@/assets/img/DE_s/three_column3.png"),
            title: "sale",
            btnLink:
              "https://www.ebay.de/str/duschdepot/Ausverkauf/_i.html?_storecat=72653713013",
            // imgLink: "#############",
          },
        ],
      },
      de_s_Duschkabine: {
        module: {
          name: "de-product-classify",
          title: "Duschkabine",
        },
        className: "three-column",
        isScale: true,
        content: [
          {
            id: 1,
            url: require("@/assets/img/DE_s/de-product-classify_img_1.jpg"),
            imgLink: "https://www.ebay.de/itm/143161971025",
            btnLink:
              "https://www.ebay.de/str/duschdepot/Duschkabinen/_i.html?_storecat=62595251013",
            title: "duschkabine",
          },
          {
            id: 2,
            url: require("@/assets/img/DE_s/de-product-classify_img_2.jpg"),
            imgLink: "https://www.ebay.de/itm/143662319196",
            btnLink:
              "https://www.ebay.de/str/duschdepot/Duschwannen/_i.html?_storecat=62595273013",
            title: "duschtasse",
          },
          {
            id: 3,
            url: require("@/assets/img/DE_s/de-product-classify_img_3.jpg"),
            imgLink: "https://www.ebay.de/itm/143618542978",
            btnLink:
              "https://www.ebay.de/str/duschdepot/Duschrinne/_i.html?_storecat=68938371013",
            title: "duschrinne",
          },
        ],
      },
      de_s_Badspiegel: {
        module: {
          name: "de-product-classify",
          title: "Badspiegel/Spiegelschrank",
        },
        className: "three-column",
        isScale: true,
        content: [
          {
            id: 1,
            url: require("@/assets/img/DE_s/de-product-classify_img_4.jpg"),
            title: "spiegelschrank",
            imgLink: "https://www.ebay.de/itm/143656742450",
            btnLink:
              "https://www.ebay.de/str/duschdepot/Spiegelschrank/_i.html?_storecat=67301270013",
          },
          {
            id: 2,
            url: require("@/assets/img/DE_s/de-product-classify_img_5.jpg"),
            title: "badspiegel rund",
            imgLink: "https://www.ebay.de/itm/142929120069",
            btnLink:
              "https://www.ebay.de/str/duschdepot/Badspiegel/_i.html?_storecat=62595271013",
          },
          {
            id: 3,
            url: require("@/assets/img/DE_s/de-product-classify_img_6.jpg"),
            title: "badspiegel rechteckig",
            imgLink: "https://www.ebay.de/itm/143408459481",
            btnLink:
              "https://www.ebay.de/str/duschdepot/Badspiegel/_i.html?_storecat=62595271013",
          },
        ],
      },
      de_s_Heizkörper: {
        module: {
          name: "de-product-classify",
          title: "Heizkörper",
        },
        className: "three-column",
        isScale: true,
        content: [
          {
            id: 1,
            url: require("@/assets/img/DE_s/de-product-classify_img_7.jpg"),
            title: "Flachheizkörper",
            imgLink: "https://www.ebay.de/itm/142935560001",
            btnLink:
              "https://www.ebay.de/str/duschdepot/Verkaufsaktionen/_i.html?_storecat=68717070013",
          },
          {
            id: 2,
            url: require("@/assets/img/DE_s/de-product-classify_img_8.jpg"),
            title: "Röhrenheizkörper",
            imgLink: "https://www.ebay.de/itm/142935487408",
            btnLink:
              "https://www.ebay.de/str/duschdepot/other/_i.html?_storecat=67757225013",
          },
          {
            id: 3,
            url: require("@/assets/img/DE_s/de-product-classify_img_9.jpg"),
            title: "Handtuchheizkörper",
            imgLink: "https://www.ebay.de/itm/143088217630",
            btnLink:
              "https://www.ebay.de/str/duschdepot/Handtuchheizkorper/_i.html?_storecat=70629780013",
          },
        ],
      },
      de_s_Zubehören: {
        module: {
          name: "de-product-classify",
          title: "Zubehören",
        },
        className: "three-column",
        isScale: true,
        content: [
          {
            id: 1,
            url: require("@/assets/img/DE_s/de-product-classify_img_10.jpg"),
            title: "Duschdichtungen",
            imgLink: "https://www.ebay.de/itm/142970892868",
            btnLink:
              "https://www.ebay.de/str/duschdepot/Zubehoren/_i.html?_storecat=62595252013",
          },
          {
            id: 2,
            url: require("@/assets/img/DE_s/de-product-classify_img_11.jpg"),
            title: "Heizkörperzubehör",
            imgLink: "https://www.ebay.de/itm/143404700914",
            btnLink:
              "https://www.ebay.de/str/duschdepot/Zubehoren/_i.html?_storecat=62595252013",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("storeInfo", ["storeName"]),
  },
  components: {
    ProductList,
    SectionTitle,
    Slide,
  },
};
</script>

<style lang="less" scoped>
.fr-container {
  .mx(auto);
  @media (min-width: 576px) {
    .wh(1170px, auto);
  }
}
.de_s-container {
  .mx(auto);
  @media (min-width: 576px) {
    .wh(1400px, auto);
  }
}
</style>
